import { createFileRoute } from "@tanstack/react-router";

import { ConfirmationView } from "../../../components/aries/ConfirmationView";
import { readConfirmationDraft } from "../../../lib/confirmationDraftStorage";

/** URL search parameters for the confirmation route. */
type ConfirmationSearch = {
  /** Employee ID for HRIS data fetch */
  employeeId: string;
};

/**
 * ARIES Confirmation Route
 *
 * Route: /aries/confirmation?employeeId=xxx
 *
 * @example
 * navigate({
 *   to: "/aries/confirmation",
 *   search: {
 *     employeeId: 'emp-123',
 *   }
 * })
 */
export const Route = createFileRoute("/_protected/aries/confirmation")({
  component: ConfirmationPage,
  validateSearch: (search: Record<string, unknown>): ConfirmationSearch => {
    const employeeId = search.employeeId;
    if (
      typeof employeeId !== "string" ||
      !employeeId ||
      employeeId.trim() === ""
    ) {
      throw new Error("employeeId is required and must be a non-empty string");
    }

    return {
      employeeId,
    };
  },
});

function ConfirmationPage() {
  const { employeeId } = Route.useSearch();
  const draft = readConfirmationDraft(employeeId);

  return (
    <ConfirmationView
      employeeId={employeeId}
      draftData={draft}
      onBack={() => window.history.back()}
    />
  );
}
